module.exports = __webpack_public_path__ + "img/ExitusForce-G.d33a7cb2.png";